import React ,{useEffect} from "react";
import Styled from "styled-components";
export default function SlsLibrary() {
  useEffect(() => {
    window.scroll(0,0)
  }, []);
  return (
    <DIV>
      <BOX>
        <H1>About the Library</H1>
        <COLOR>
          <BOTTOM className="bottom">
            <p>
              The Library at Prof NR Madhava Menon Interdisciplinary Centre for 
              Research Ethics and Protocols, offers the students, research scholars 
              and faculty with the wealth of knowledge, resources, space and 
              environment to discover and unravel knowledge. The ICREP library 
              provides a world of books primarily latest law books as well as books 
              on bioethics, computer science, biological science, research methodology etc. 
              The resources are customized and tailored to meet the needs of learners. 
              It encompasses not only stacks of books like encyclopaedias’, case reports, 
              textbooks, reporters, journals and commentaries but also has online 
              resources in the form of legal database wherein the students access 
              an array of legal materials. These databases include statutes, case 
              law, regulations, and legal commentaries, enabling students to conduct 
              in-depth research. This library uses the world's first free and open-source 
              library system, the KOHA library software wherein access to this library 
              can be made anywhere from the world and the resources can be identified easily. 
              Trained Library staff help the students navigate through the resources and 
              the well-maintained comfortable ambience directs young minds to meaningful 
              research and learning.              
            </p>
            <h2>Mission of the Library</h2>
            <ul>
                <li>Support the University in its learning, teaching, and research endeavours.</li>
                <li>Provide learners with information-intensive resources.</li>
                <li>Help learners navigate through diverse resources with ease.</li>
                <li>Enable learners to acquire the necessary skills in identifying and applying resources in their specific areas of study.</li>
                <li>Provide a robust digital infrastructure that supports innovative services to learners by understanding their requirements.</li>
            </ul>
          </BOTTOM>
        </COLOR>
      </BOX>
    </DIV>
  );
}
const DIV = Styled.div`
background: #FAFAFA;
display:flex ;
justify-content:center;
align-items: center;
width:100%;

`;
const COLOR = Styled.div`
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
    background: white;
    padding: 20px 30px 20px 30px;
    margin-bottom:50px;
`;

const BOX = Styled.div`

width:85%;

margin:0 auto;

`;
const H1 = Styled.h1`
font-family: Oswald;
font-style: normal;
font-weight: normal;
font-size: 34px;
line-height:39px;
margin-top:50px;
margin-bottom:28px;
font-weight:500;
color: #E01E38;
padding-top: 20px;
display:flex;
@media (max-width:860px){
  font-size: 34px;
}
@media (max-width:660px){
  font-size: 32px;
}
@media (max-width:540px){
  font-size: 30px;
}
@media (max-width:460px){
  font-size: 28px;
}
@media (max-width:368px){
  font-size: 26px;
}`;

const BOTTOM = Styled.div`

  p{
    font-family: PT Serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    margin-bottom:20px;
    text-align:justify;
    @media (max-width:660px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
    @media (max-width:460px){
      font-size: 16px;
    }
    @media (max-width:368px){
      font-size: 16px;
    }
  }
 
  `;
